import React from 'react'
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { DocumentReportIcon, NewspaperIcon, XCircleIcon } from '@heroicons/react/outline'

function ContextTypeModal({
    setShowContextType,
    showContextType,
    setShowVpropMod,
    setShowTempMod
}) {

    const AddVProp = () =>{
        setShowVpropMod(true)
        // setShowContextType(false)

    }
    return (
        <Transition.Root show={showContextType} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed z-10 inset-0 overflow-y-auto"
          // initialFocus={completeButtonRef}
          open={showContextType}
          onClose={setShowContextType}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
  
            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                <button className="float-right font bold cursor-pointer focus:outline-none"
                onClick={() => setShowContextType(false)}
                >
                    <XCircleIcon className="h-6 text-gray-700"/>
                </button>
                <div className="mb-4 font-bold text-lg text-gray-800">
                    Add Context
                </div>
                <div className="flex">
                    <div
                    style={{textAlign:'-webkit-center'}}
                    className="rounded-md border-2 border-green-600 p-4 mr-6 w-1/2 cursor-pointer hover:shadow-lg"
                    onClick={() => setShowTempMod(true)}
                    >
                        <DocumentReportIcon className="h-11 mb-2 text-green-600"/>
                        <p className="font-semibold text-base mb-2 text-green-600">Add a Template</p>
                        <p className="font-medium">
                            Add one of your favorite or most effective templates
                        </p>
                    </div>
                    <div
                    style={{textAlign:'-webkit-center'}}
                    className="rounded-md border-2 border-blue-600 p-4 w-1/2 cursor-pointer hover:shadow-lg"
                    onClick={() => AddVProp()}
                    >
                        <NewspaperIcon className="h-11 mb-2 text-blue-600"/>
                        <p className="font-semibold text-base mb-2 text-blue-600">Add a Value Prop</p>
                        <p className="font-medium">
                            Add a Value Prop and Pain Point
                        </p>
                    </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    )
}

export default ContextTypeModal
